const Levels = {
  Month: '%Y-%m',
  Week: '%Y-%V',
  Day: '%Y-%m-%d',
  Hour: '%Y-%m-%d %H',
};

export default Levels;
